/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconTrident = createReactComponent("trident", "IconTrident", [
  ["path", { d: "M3 6l2 -2v3a7 7 0 0 0 14 0v-3l2 2", key: "svg-0" }],
  ["path", { d: "M12 21v-18l-2 2m4 0l-2 -2", key: "svg-1" }]
]);

export { IconTrident as default };
//# sourceMappingURL=IconTrident.js.map
